import { DEFAULT_SHOW_WIREFRAME, DEFAULT_SHOW_POINT_CLOUD } from "../config.js";
import keypointClasses from "../../data/keypoint_classes_all.json";

// Global state object
const globalState = {
    scene: null,
    camera: null,
    renderer: null,
    mesh: null,
    controls: null,
    boundaryScene: null,
    boundaryCamera: null,
    boundaryRenderer: null,
    boundaryMesh: null,
    boundaryControls: null,
    simplifiedBoundaryScene: null,
    simplifiedBoundaryCamera: null,
    simplifiedBoundaryRenderer: null,
    simplifiedBoundaryMesh: null,
    simplifiedBoundaryControls: null,
    showWireframe: DEFAULT_SHOW_WIREFRAME,
    showPointCloud: DEFAULT_SHOW_POINT_CLOUD,
    wireframeMaterial: null,
    pointsMaterial: null,
    ambientLight: null,
    directionalLight1: null,
    directionalLight2: null,
    loadingFile: false,
    processingFile: false,
    boundaryPoints: null,
    boundaryLines: null,
    simplifiedBoundaryPoints: null,
    simplifiedBoundaryLines: null,
    labelRenderer: null,
    boundaryLabelRenderer: null,
    simplifiedBoundaryLabelRenderer: null,
    classLabels: [],
    keypoints: {},
    keypointLabels: [],
    showToothIDForKeypoints: false,
    labelingMode: "keypoint",
    annotationClasses: keypointClasses,
    currentClassId: 1,
    showKeypointLabels: true,
    showMarginalRidgeLines: true,
    brightnessAmount: 1.5,
    objFiles: [{ name: "currentFile.obj" }],
    currentFileIndex: 0,
    separationPhase: 0,
    separationData: {
        originalMesh: null,
        segmentedMesh: null,
        analyzedTeeth: null,
        finalResult: null
    },
    multiViewRenderers: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewScenes: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewCameras: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewControls: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewLabelRenderers: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    // Overlay view for arrangement mode
    overlayViewMode: "dual", // "dual" or "overlay"
    overlayRenderer: null,
    overlayScene: null,
    overlayCamera: null,
    overlayControls: null,
    overlayLabelRenderer: null,
    arrangementOriginalObjects: null,
    arrangementTransformedObjects: null,
    // Feedback review mode state
    feedbackMode: false,
    feedbackData: [],
    currentFeedbackIndex: 0,
    feedbackManager: null,
    // Displacement table data
    displacementTable: null,
    lastArrangementInfoJson: null
};

export { globalState };
